/* =========================================================
  PET CUSTOMIZER (Step 1–4)
  - Upload -> Frame -> Size -> Message/Extras -> Checkout
  - Cloudflare R2 multipart uploads
  - Shopify "shadow file" for clickable file in order
  - Price updates from current product variants
  - Add-ons as separate products + price included in UI
  - ✅ Bilingual (EN/SV) incl. static HTML text
========================================================= */

const TOTAL_STEPS = 4;

/* -----------------------------
  0) PET COUNT FROM TAGS
------------------------------ */
window.requiredImageCount = 1;
try {
  if (window.productTags && Array.isArray(window.productTags)) {
    const petTag = window.productTags.find(t => /^(\d+)\s*pet(s)?$/i.test(String(t || "").trim()));
    if (petTag) {
      const m = String(petTag).match(/^(\d+)/);
      if (m && m[1]) window.requiredImageCount = parseInt(m[1], 10);
    }
  }
} catch (e) {}

const REQUIRED_IMAGES = Math.min(Math.max(Number(window.requiredImageCount) || 1, 1), 4);

/* -----------------------------
  I18N (EN/SV) — robust locale detection
------------------------------ */
const LOCALE = (() => {
  const qp = new URLSearchParams(location.search);
  const qpLocale = (qp.get("locale") || qp.get("lang") || "").toLowerCase();
  if (qpLocale) return qpLocale;

  const path = location.pathname.toLowerCase();
  // Shopify can have /sv, /en etc depending on language setup
  if (path.startsWith("/sv")) return "sv";

  const shop = (window.Shopify && typeof Shopify.locale === "string") ? Shopify.locale.toLowerCase() : "";
  if (shop) return shop;

  return (document.documentElement.lang || "en").toLowerCase();
})();

const LANG_KEY = LOCALE.startsWith("sv") ? "sv" : "en";

const I18N = {
  en: {
    // dynamic / system
    progress: (step, total) => `Step ${step} of ${total}`,
    uploadedAlt: "Uploaded photo",

    alreadySelected: (n) => `You already selected ${n} photo${n > 1 ? "s" : ""}. Remove one to add a new one.`,
    selectExactly: (n) => `Please select exactly ${n} photo${n > 1 ? "s" : ""}.`,
    chooseSize: "Please choose a size to continue.",
    uploadFailed: "One or more uploads failed. Please remove the photo(s) and try again.",
    uploadUnavailable: "Upload system is temporarily unavailable. Please try again.",

    uploadingStatus: (done, required) => `Uploading your photos… ${done}/${required}. Most uploads take just a few seconds.`,

    stillUploading: "Still uploading your photos. Please wait a moment.",
    adding: "ADDING…",
    variantMissing: "Could not find the selected variant. Please try another option.",
    addToCartFail: "Something went wrong adding to cart. Please try again.",
    networkError: "Network error. Please try again.",
    addOnMisconfigured: (title) => `Add-on is not configured correctly: ${title}. Please contact support.`,
    addOnsFailedButMainAdded: "Add-ons could not be added, but your portrait was added to cart.",

    frameBlack: "Black",
    frameWhite: "White",
    frameLightWood: "Light wood",

    addOnDigital: "Digital download",
    addOnPriority: "Priority order",

    appliesTo: "Applies to",
    styleFallback: "Main portrait",
    msgLabel: "Message to artist",

    btnNext: "NEXT",
    btnBack: "GO BACK",
    btnNextPricePrefix: "NEXT –",
    btnCheckoutPrefix: "GO TO CHECKOUT –",

    // static HTML strings
    s1_title: "Upload your pet´s photo",
    s1_ariaUpload: "Upload pet photo",
    s1_boxLine1: "From muse to masterpiece,",
    s1_boxLine2: "upload your photo",
    s1_photosAdded: "photos added",

    s2_title: "Select your frame",
    s2_subtitle: "Choose the frame color you like",
    s2_note: "Frame color can be adjusted after preview",

    s3_title: "Choose your size",
    s3_subtitle: "Find the perfect fit for your space",

    s4_title: "Add a personal touch",
    s4_subtitle: "Leave message to artist",
    s4_placeholder: "Ex. remove crown",
    s4_extrasTitle: "Extras",

    s4_extraDigitalTitle: "Add Digital Download",
    s4_extraDigitalDesc: "Get a digital high resolution copy sent to your email",
    s4_extraPriorityTitle: "Priority Order",
    s4_extraPriorityDesc: "Skip the queue! Get your preview in 24 hours.",

    s4_gateDefault: "Uploading your photos…",

    badge1_html: "Preview included<br>before printing",
    badge2: "Unlimited revisions",
    badge3_html: "Full refund if<br>you’re not happy<br>with the preview",

    guarantee: "100% Satisfaction Guarantee"
  },

  sv: {
    // dynamic / system
    progress: (step, total) => `Steg ${step} av ${total}`,
    uploadedAlt: "Uppladdad bild",

    alreadySelected: (n) => `Du har redan valt ${n} bild${n > 1 ? "er" : ""}. Ta bort en för att lägga till en ny.`,
    selectExactly: (n) => `Välj exakt ${n} bild${n > 1 ? "er" : ""}.`,
    chooseSize: "Välj en storlek för att fortsätta.",
    uploadFailed: "En eller flera uppladdningar misslyckades. Ta bort bilden/bilderna och försök igen.",
    uploadUnavailable: "Uppladdningen är tillfälligt otillgänglig. Försök igen.",

    uploadingStatus: (done, required) => `Laddar upp dina bilder… ${done}/${required}. Det tar oftast bara några sekunder.`,

    stillUploading: "Dina bilder laddas fortfarande upp. Vänta en liten stund.",
    adding: "LÄGGER TILL…",
    variantMissing: "Kunde inte hitta den valda varianten. Testa ett annat val.",
    addToCartFail: "Något gick fel när vi lade i varukorgen. Försök igen.",
    networkError: "Nätverksfel. Försök igen.",
    addOnMisconfigured: (title) => `Tillvalet är inte korrekt konfigurerat: ${title}. Kontakta support.`,
    addOnsFailedButMainAdded: "Tillval kunde inte läggas till, men ditt porträtt ligger i varukorgen.",

    frameBlack: "Svart",
    frameWhite: "Vit",
    frameLightWood: "Ljus trä",

    addOnDigital: "Digital nedladdning",
    addOnPriority: "Prioriterad order",

    appliesTo: "Gäller för",
    styleFallback: "Huvudporträtt",
    msgLabel: "Meddelande till konstnären",

    btnNext: "NÄSTA",
    btnBack: "TILLBAKA",
    btnNextPricePrefix: "NÄSTA –",
    btnCheckoutPrefix: "TILL KASSAN –",

    // static HTML strings
    s1_title: "Ladda upp din bild",
    s1_ariaUpload: "Ladda upp bild på ditt husdjur",
    s1_boxLine1: "Från musa till mästerverk,",
    s1_boxLine2: "ladda upp din bild",
    s1_photosAdded: "bilder uppladdade",

    s2_title: "Välj din ram",
    s2_subtitle: "Välj den ramfärg du gillar",
    s2_note: "Ramfärg kan ändras under förhandsgranskningen",

    s3_title: "Välj storlek",
    s3_subtitle: "Hitta den perfekta storleken för ditt hem",

    s4_title: "Lägg till en personlig touch",
    s4_subtitle: "Lämna ett meddelande till konstnären",
    s4_placeholder: "T.ex. ta bort kronan",
    s4_extrasTitle: "Tillval",

    s4_extraDigitalTitle: "Digital nedladdning",
    s4_extraDigitalDesc: "Få en digital högupplöst kopia skickad till din e-post",
    s4_extraPriorityTitle: "Prioriterad order",
    s4_extraPriorityDesc: "Gå före i kön! Få din förhandsgranskning inom 24 timmar.",

    s4_gateDefault: "Laddar upp dina mästerverk…",

    badge1_html: "Förhandsgranskning<br>ingår före tryck",
    badge2: "Obegränsade ändringar",
    badge3_html: "Full återbetalning om du inte godkänner previewn",

    guarantee: "100% nöjd-kund-garanti"
  }
};

const T = I18N[LANG_KEY];

/* -----------------------------
  Static HTML translation patch
  (because your headings/buttons/badges are hardcoded in HTML)
------------------------------ */
function setText(sel, text) {
  const el = document.querySelector(sel);
  if (el) el.textContent = text;
}
function setHTML(sel, html) {
  const el = document.querySelector(sel);
  if (el) el.innerHTML = html;
}
function setAttr(sel, attr, value) {
  const el = document.querySelector(sel);
  if (el) el.setAttribute(attr, value);
}

function applyStaticTranslations() {
  // Progress initial text
  setText("#progress-text", T.progress(1, TOTAL_STEPS));

  // Step 1
  setText('.step[data-step="1"] .section-title', T.s1_title);
  setAttr("#upload-area", "aria-label", T.s1_ariaUpload);

  const step1Titles = document.querySelectorAll('.step[data-step="1"] .upload-title');
  if (step1Titles[0]) step1Titles[0].textContent = T.s1_boxLine1;
  if (step1Titles[1]) step1Titles[1].textContent = T.s1_boxLine2;

  // Upload hint: keep existing span nodes
  const hint = document.querySelector('.step[data-step="1"] .upload-hint');
  const counter = document.getElementById("upload-counter");
  const req = document.getElementById("upload-required");
  if (hint && counter && req) {
    hint.innerHTML = "";
    hint.appendChild(counter);
    hint.appendChild(document.createTextNode("/"));
    hint.appendChild(req);
    hint.appendChild(document.createTextNode(" " + T.s1_photosAdded));
  }

  // Step 2
  setText('.step[data-step="2"] .section-title', T.s2_title);
  setText('.step[data-step="2"] .section-subtitle', T.s2_subtitle);
  setText('.step[data-step="2"] .step2-note', T.s2_note);

  // Frame labels in HTML
  document.querySelectorAll('.frame-card .frame-label').forEach((el) => {
    const card = el.closest(".frame-card");
    const key = card?.dataset?.frame;
    if (key === "black-wood") el.textContent = T.frameBlack;
    if (key === "white-wood") el.textContent = T.frameWhite;
    if (key === "light-wood") el.textContent = T.frameLightWood;
  });

  // Step 3
  setText('.step[data-step="3"] .section-title', T.s3_title);
  setText('.step[data-step="3"] .section-subtitle', T.s3_subtitle);

  // Step 4
  setText('.step[data-step="4"] .step4-title', T.s4_title);
  setText('.step[data-step="4"] .step4-subtitle', T.s4_subtitle);
  setAttr("#message-to-artist", "placeholder", T.s4_placeholder);
  setText('.step[data-step="4"] .step4-extras-title', T.s4_extrasTitle);

  // Extras cards (title/desc)
  const dTitle = document.querySelector('label[for="extra-digital"] .extras-card-title');
  const dDesc  = document.querySelector('label[for="extra-digital"] .extras-card-desc');
  if (dTitle) dTitle.innerHTML = `${T.s4_extraDigitalTitle} <span style="font-weight:900;">(+49kr)</span>`;
  if (dDesc)  dDesc.textContent = T.s4_extraDigitalDesc;

  const pTitle = document.querySelector('label[for="extra-priority"] .extras-card-title');
  const pDesc  = document.querySelector('label[for="extra-priority"] .extras-card-desc');
  if (pTitle) pTitle.innerHTML = `${T.s4_extraPriorityTitle} <span style="font-weight:900;">(+99kr)</span>`;
  if (pDesc)  pDesc.textContent = T.s4_extraPriorityDesc;

  // Upload gate default
  setText("#step5-uploadtext", T.s4_gateDefault);

  // Badges (3)
  const badgeDivs = document.querySelectorAll(".step5-badge div");
  if (badgeDivs[0]) badgeDivs[0].innerHTML = T.badge1_html;
  if (badgeDivs[1]) badgeDivs[1].textContent = T.badge2;
  if (badgeDivs[2]) badgeDivs[2].innerHTML = T.badge3_html;

  // Guarantee pill label
  const guarantee = document.querySelector(".guarantee-pill span:last-child");
  if (guarantee) guarantee.textContent = T.guarantee;

  // Buttons (safe text-only ones)
  setText("#next-from-upload", T.btnNext);
  setText("#back-to-upload", T.btnBack);
  setText("#back-to-frame", T.btnBack);
  setText("#back-from-message", T.btnBack);

  // Buttons that include price spans: rebuild text + keep span nodes
  const b2 = document.querySelector("#next-step2");
  if (b2) {
    const price = b2.querySelector("#next-price");
    b2.textContent = "";
    b2.appendChild(document.createTextNode(T.btnNextPricePrefix + " "));
    if (price) b2.appendChild(price);
  }

  const b3 = document.querySelector("#next-step3");
  if (b3) {
    const price = b3.querySelector("#next-price-step3");
    b3.textContent = "";
    b3.appendChild(document.createTextNode(T.btnNextPricePrefix + " "));
    if (price) b3.appendChild(price);
  }

  const cta = document.querySelector("#add-to-cart");
  if (cta) {
    const price = cta.querySelector("#live-price");
    cta.textContent = "";
    cta.appendChild(document.createTextNode(T.btnCheckoutPrefix + " "));
    if (price) cta.appendChild(price);
  }
}

/* -----------------------------
  0.5) ADD-ONS CONFIG (EDIT ME) UPPDATERA EFTER LAUNCH VECKAN ÄR SLUT MED DE GAMLA PRISERNA 49KR, 99KR
------------------------------ */
const ADD_ONS = {
  digital: {
    checkboxSelector: "#extra-digital",
    titleKey: "addOnDigital",
    variantId: "56805127913816",
    priceKr: 49
  },
  priority: {
    checkboxSelector: "#extra-priority",
    titleKey: "addOnPriority",
    variantId: "56805125292376",
    priceKr: 99
  }
};

function getSelectedAddOnKeys() {
  const keys = [];
  for (const [key, cfg] of Object.entries(ADD_ONS)) {
    const el = document.querySelector(cfg.checkboxSelector);
    if (el && el.checked) keys.push(key);
  }
  return keys;
}

function getSelectedAddOnsTotalKr() {
  const keys = getSelectedAddOnKeys();
  return keys.reduce((sum, k) => sum + (Number(ADD_ONS[k]?.priceKr) || 0), 0);
}

/* -----------------------------
  1) STATE / DOM
------------------------------ */
let selectedType = "poster";        // locked
let selectedFrame = "black-wood";   // MUST match HTML data-frame keys
let selectedSize  = "a4";           // MUST match HTML data-size keys

let uploadedFiles = [];           // File[]
let uploadJobs = [];              // [{ key, uploadId, fileUrl, done, partSize }]
let uploadedUrls = [];            // [fileUrl]
let activeUploads = new Map();    // index -> AbortController

const $  = (sel) => document.querySelector(sel);
const $$ = (sel) => Array.from(document.querySelectorAll(sel));

const uploadArea  = $("#upload-area");
const uploadError = $("#upload-error");
const previewGrid = $("#preview-grid");

const step5Spinner    = $("#step5-spinner");
const step5UploadText = $("#step5-uploadtext");

const addToCartBtn = $("#add-to-cart");

/* -----------------------------
  1.1) WORKER BASE (EDIT ME)
------------------------------ */
const UPLOAD_API_BASE = "https://uploads.purrtraitsstudio.com";

/* -----------------------------
  2) HELPERS
------------------------------ */
function setError(msg) {
  if (!uploadError) return;
  uploadError.textContent = msg || "";
}

function currentStep() {
  const el = document.querySelector(".step.active");
  return el ? Number(el.dataset.step) : 1;
}

function updateProgressUI(n) {
  const fill = $("#progress-fill");
  const text = $("#progress-text");
  if (!fill || !text) return;

  const step = Math.max(1, Math.min(TOTAL_STEPS, Number(n) || 1));
  text.textContent = T.progress(step, TOTAL_STEPS);
  const pct = TOTAL_STEPS <= 1 ? 100 : ((step - 1) / (TOTAL_STEPS - 1)) * 100;
  fill.style.width = `${pct}%`;
}

function normalizeSizeDisplay(sizeKey){
  const s = String(sizeKey || "").trim().toLowerCase();
  if (s === "a4") return "A4";
  if (/^\d+x\d+$/.test(s)) return s.replace("x", "×") + " cm";
  return sizeKey || "";
}

function getCurrentProductHandle(){
  const m = window.location.pathname.match(/\/products\/([^\/]+)/);
  return m ? m[1] : null;
}

async function fetchProductJsonByHandle(handle){
  const res = await fetch(`/products/${handle}.js`);
  if (!res.ok) throw new Error("Could not load product JSON");
  return await res.json();
}

/* -----------------------------
  2.1) FIND VARIANT ID
------------------------------ */
async function getBaseVariantIdAsync(){
  const handle = getCurrentProductHandle();
  if (!handle) return null;

  const product  = await fetchProductJsonByHandle(handle);
  const variants = Array.isArray(product.variants) ? product.variants : [];

  const FRAME_TITLE = {
    "black-wood": "Black Frame",
    "white-wood": "White Frame",
    "light-wood": "Light Wood Frame",
  };

  const SIZE_TITLE = {
    "a4": "A4",
    "30x40": "30 x 40 cm",
    "40x50": "40 x 50 cm",
  };

  const frameLabel = FRAME_TITLE[String(selectedFrame || "").toLowerCase()] || "";
  const sizeLabel  = SIZE_TITLE[String(selectedSize  || "").toLowerCase()]  || "";
  if (!frameLabel || !sizeLabel) return null;

  const norm = (s) => String(s || "")
    .toLowerCase()
    .replace(/×/g, "x")
    .replace(/\s+/g, " ")
    .replace(/\s*x\s*/g, " x ")
    .replace(/\s*cm\b/g, " cm")
    .trim();

  const wantedExact = norm(`${frameLabel} ${sizeLabel}`);

  let v = variants.find(x => norm(x.title) === wantedExact);
  if (v) return String(v.id);

  const frameNeed = norm(frameLabel);
  const sizeNeed  = norm(sizeLabel);

  v = variants.find(x => {
    const t = norm(x.title);
    return t.includes(frameNeed) && t.includes(sizeNeed);
  });

  return v ? String(v.id) : null;
}

/* -----------------------------
  2.2) Shopify "shadow file"
------------------------------ */
async function makeShopifyShadowFile(originalFile, idx) {
  const MAX_DIM = 1600;
  const QUALITY = 0.8;

  try {
    const img = await new Promise((resolve, reject) => {
      const i = new Image();
      i.onload = () => resolve(i);
      i.onerror = reject;
      i.src = URL.createObjectURL(originalFile);
    });

    let { width, height } = img;
    const scale = Math.min(1, MAX_DIM / Math.max(width, height));
    const w = Math.max(1, Math.round(width * scale));
    const h = Math.max(1, Math.round(height * scale));

    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("no canvas ctx");

    ctx.drawImage(img, 0, 0, w, h);

    const blob = await new Promise((resolve) => {
      canvas.toBlob((b) => resolve(b), "image/jpeg", QUALITY);
    });

    if (!blob) throw new Error("toBlob failed");

    const niceName = `Pet photo ${idx}.jpg`;
    return new File([blob], niceName, { type: "image/jpeg" });
  } catch (e) {
    const niceName = `Pet photo ${idx}${originalFile?.name ? " - " + originalFile.name : ""}`;
    try {
      return new File([originalFile], niceName, { type: originalFile.type || "application/octet-stream" });
    } catch (_) {
      return originalFile;
    }
  }
}

/* -----------------------------
  3) PRICE (includes add-ons)
------------------------------ */
async function updatePriceImmediate() {
  const variantId = await getBaseVariantIdAsync();

  const nextPrice = $("#next-price");
  const step3Span = $("#next-price-step3");
  const liveSpan  = $("#live-price");

  if (!variantId) {
    if (nextPrice) nextPrice.textContent = "—";
    if (step3Span) step3Span.textContent = "—";
    if (liveSpan) liveSpan.textContent = "—";
    window.currentTotalPrice = 0;
    return;
  }

  try {
    const res = await fetch(`/variants/${variantId}.js`);
    if (!res.ok) throw new Error("variant fetch failed");
    const data = await res.json();

    const baseKr = Math.round((data.price || 0) / 100);
    const addOnsKr = getSelectedAddOnsTotalKr();

    // Automatisk kampanjrabatt AVSTÄNGD:
    // 1 djur = 100 kr
    // 2 djur = 200 kr
    // 3 djur = 300 kr
    // 4 djur = 400 kr
    // const discountKr = 100 * REQUIRED_IMAGES;

    // Kampanj:
    // const totalKr = Math.max(0, baseKr - discountKr + addOnsKr);

    // Ordinarie pris:
    const totalKr = Math.max(0, baseKr + addOnsKr);

    window.currentTotalPrice = totalKr;

    const formatted = `${totalKr} kr`;
    const formattedBtn = `${totalKr}KR`;

    if (nextPrice) nextPrice.textContent = formatted;
    if (step3Span) step3Span.textContent = formatted;
    if (liveSpan) liveSpan.textContent = formattedBtn;

    updateSelectionLine();
  } catch (e) {
    window.currentTotalPrice = 0;
    if (nextPrice) nextPrice.textContent = "—";
    if (step3Span) step3Span.textContent = "—";
    if (liveSpan) liveSpan.textContent = "—";
  }
}
window.updatePriceImmediate = updatePriceImmediate;
window.updatePrice = updatePriceImmediate;

/* -----------------------------
  3.1) LIVE SELECTION LINE
------------------------------ */
function updateSelectionLine(){
  const el = $("#selection-line");
  if (!el) return;

  const name = (window.productTitle || "").trim();
  const size = normalizeSizeDisplay(selectedSize);

  const frameNice =
    selectedFrame === "black-wood" ? T.frameBlack :
    selectedFrame === "white-wood" ? T.frameWhite :
    selectedFrame === "light-wood" ? T.frameLightWood :
    selectedFrame;

  const selectedAddOns = getSelectedAddOnKeys()
    .map(k => T[ADD_ONS[k]?.titleKey])
    .filter(Boolean);

  const parts = [name, size, frameNice].filter(Boolean);
  const baseLine = parts.length ? parts.join(" · ") : "—";

  el.textContent = selectedAddOns.length
    ? `${baseLine} · + ${selectedAddOns.join(", ")}`
    : baseLine;
}

/* -----------------------------
  4) STEP 1 UI (append + remove-one)
------------------------------ */
function updateUploadUI() {
  const counter = $("#upload-counter");
  const required = $("#upload-required");
  if (counter) counter.textContent = String(uploadedFiles.length);
  if (required) required.textContent = String(REQUIRED_IMAGES);

  const nextBtn = $("#next-from-upload");
  if (nextBtn) nextBtn.disabled = (uploadedFiles.length !== REQUIRED_IMAGES);

  if (uploadArea) {
    if (uploadedFiles.length >= REQUIRED_IMAGES) uploadArea.classList.add("disabled");
    else uploadArea.classList.remove("disabled");
  }
}

function renderPreviews() {
  if (!previewGrid) return;
  previewGrid.innerHTML = "";

  uploadedFiles.forEach((file, index) => {
    const wrap = document.createElement("div");
    wrap.className = "preview-thumb";

    const img = document.createElement("img");
    img.alt = T.uploadedAlt;
    img.src = URL.createObjectURL(file);

    const btn = document.createElement("button");
    btn.className = "preview-remove";
    btn.type = "button";
    btn.textContent = "×";
    btn.dataset.index = String(index);

    wrap.appendChild(img);
    wrap.appendChild(btn);
    previewGrid.appendChild(wrap);
  });

  updateUploadUI();
}

function abortUploadAtIndex(i){
  const ac = activeUploads.get(i);
  if (ac) {
    try { ac.abort(); } catch(e){}
  }
  activeUploads.delete(i);
}

function handleSelectedFiles(fileList) {
  setError("");

  const incoming = Array.from(fileList || []).filter(f => f && f.type && f.type.startsWith("image/"));
  if (!incoming.length) return;

  const room = REQUIRED_IMAGES - uploadedFiles.length;
  if (room <= 0) {
    setError(T.alreadySelected(REQUIRED_IMAGES));
    return;
  }

  const toAdd = incoming.slice(0, room);
  uploadedFiles = uploadedFiles.concat(toAdd);

  for (let k=0;k<toAdd.length;k++){
    uploadJobs.push({ done:false, fileUrl:"" });
    uploadedUrls.push("");
  }

  renderPreviews();
  startUploadsForNotStarted();
}

if (previewGrid) {
  previewGrid.addEventListener("click", (e) => {
    const t = e.target;
    if (!(t instanceof HTMLElement)) return;
    if (!t.classList.contains("preview-remove")) return;

    const idx = Number(t.dataset.index);
    if (Number.isNaN(idx)) return;

    abortUploadAtIndex(idx);

    uploadedFiles.splice(idx, 1);
    uploadJobs.splice(idx, 1);
    uploadedUrls.splice(idx, 1);

    setError("");
    renderPreviews();
    updateStep5GateUI();
  });
}

/* -----------------------------
  5) Upload implementation (Worker multipart)
------------------------------ */
async function apiInitUploads(files){
  const payload = {
    orderDraftId: "",
    files: files.map(f => ({ name: f.name, type: f.type, size: f.size }))
  };

  const res = await fetch(`${UPLOAD_API_BASE}/api/upload/init`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error((data && (data.error || data.message)) || `init failed (${res.status})`);
  if (!data || !Array.isArray(data.uploads)) throw new Error("init returned unexpected JSON");
  return data.uploads;
}

async function apiUploadPart({ key, uploadId, partNumber, chunk }, signal){
  const u = `${UPLOAD_API_BASE}/api/upload/part?key=${encodeURIComponent(key)}&uploadId=${encodeURIComponent(uploadId)}&partNumber=${partNumber}`;
  const res = await fetch(u, { method: "PUT", body: chunk, signal });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error((data && (data.error || data.message)) || `part ${partNumber} failed (${res.status})`);
  return data;
}

async function apiComplete({ key, uploadId, parts }){
  const res = await fetch(`${UPLOAD_API_BASE}/api/upload/complete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ key, uploadId, parts }),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok) throw new Error((data && (data.error || data.message)) || `complete failed (${res.status})`);
  return data;
}

function startUploadsForNotStarted(){
  if (!uploadedFiles.length) return;

  const notStartedIndices = uploadJobs
    .map((j, i) => ({ j, i }))
    .filter(x => !x.j.key && !x.j.done);

  if (!notStartedIndices.length) return;

  (async () => {
    try {
      const files = notStartedIndices.map(x => uploadedFiles[x.i]);
      const uploadsMeta = await apiInitUploads(files);

      uploadsMeta.forEach((meta, idx) => {
        const targetIndex = notStartedIndices[idx].i;
        uploadJobs[targetIndex] = {
          ...uploadJobs[targetIndex],
          key: meta.key,
          uploadId: meta.uploadId,
          partSize: meta.partSize,
          fileUrl: meta.fileUrl,
          done: false,
        };
      });

      for (const x of notStartedIndices) {
        const i = x.i;
        uploadOneFileAtIndex(i).catch(err => {
          console.error("Upload failed index", i, err);
          setError(T.uploadFailed);
          updateStep5GateUI();
        });
      }

      updateStep5GateUI();
    } catch (err) {
      console.error("Init uploads failed", err);
      setError(T.uploadUnavailable);
      updateStep5GateUI();
    }
  })();
}

async function uploadOneFileAtIndex(i){
  const file = uploadedFiles[i];
  const job  = uploadJobs[i];
  if (!file || !job?.key || !job?.uploadId) throw new Error("Missing upload job meta");

  const ac = new AbortController();
  activeUploads.set(i, ac);

  const partSize = Number(job.partSize) || (10 * 1024 * 1024);
  const partsEtags = [];
  const totalParts = Math.max(1, Math.ceil(file.size / partSize));

  for (let partNumber = 1; partNumber <= totalParts; partNumber++) {
    if (ac.signal.aborted) throw new Error("aborted");

    const start = (partNumber - 1) * partSize;
    const end   = Math.min(start + partSize, file.size);
    const chunk = file.slice(start, end);

    const r = await apiUploadPart({
      key: job.key,
      uploadId: job.uploadId,
      partNumber,
      chunk
    }, ac.signal);

    partsEtags.push({ partNumber: r.partNumber, etag: r.etag });
    updateStep5GateUI();
  }

  await apiComplete({ key: job.key, uploadId: job.uploadId, parts: partsEtags });

  uploadJobs[i].done = true;
  uploadedUrls[i] = job.fileUrl;

  activeUploads.delete(i);
  updateStep5GateUI();
}

/* -----------------------------
  6) FINAL STEP Gate UI (Step 4)
------------------------------ */
function updateStep5GateUI() {
  if (!addToCartBtn) return;
  if (currentStep() !== 4) return;

  const doneCount = uploadJobs.filter(j => j && j.done).length;
  const required  = REQUIRED_IMAGES;
  const done      = (doneCount >= required) && uploadedUrls.filter(Boolean).length >= required;

  if (step5Spinner) step5Spinner.classList.toggle("on", !done);

  if (step5UploadText) {
    step5UploadText.textContent = done ? "" : T.uploadingStatus(doneCount, required);
  }

  addToCartBtn.disabled = !done;
}

/* -----------------------------
  7) STEP NAV (Step 1–4)
------------------------------ */
function gotoStep(n) {
  $$(".step").forEach(s => s.classList.remove("active"));
  const el = document.querySelector(`.step[data-step="${n}"]`);
  if (el) el.classList.add("active");

  updateProgressUI(n);
  updatePriceImmediate();
  updateSelectionLine();

  if (n === 4) updateStep5GateUI();
}

$("#next-from-upload")?.addEventListener("click", () => {
  if (uploadedFiles.length !== REQUIRED_IMAGES) {
    alert(T.selectExactly(REQUIRED_IMAGES));
    return;
  }
  gotoStep(2);
});

$("#next-step2")?.addEventListener("click", () => gotoStep(3));

$("#next-step3")?.addEventListener("click", () => {
  const sel = document.querySelector(".size-card.selected");
  if (!sel) { alert(T.chooseSize); return; }
  selectedSize = sel.dataset.size || selectedSize;
  updatePriceImmediate();
  updateSelectionLine();
  gotoStep(4);
});

$("#back-to-upload")?.addEventListener("click", () => gotoStep(1));
$("#back-to-frame")?.addEventListener("click", () => gotoStep(2));
$("#back-from-message")?.addEventListener("click", () => gotoStep(3));

/* -----------------------------
  8) UI BINDINGS
------------------------------ */
$$(".frame-card").forEach(card => {
  card.addEventListener("click", () => {
    $$(".frame-card").forEach(c => c.classList.remove("selected"));
    card.classList.add("selected");
    selectedFrame = card.dataset.frame || selectedFrame;
    updatePriceImmediate();
    updateSelectionLine();
  });
});

$$(".size-card").forEach(card => {
  card.addEventListener("click", () => {
    $$(".size-card").forEach(s => s.classList.remove("selected"));
    card.classList.add("selected");
    selectedSize = card.dataset.size || selectedSize;
    updatePriceImmediate();
    updateSelectionLine();
  });
});

// Extras (affect price UI + selection line)
["extra-digital","extra-priority"].forEach(id => {
  const el = document.getElementById(id);
  if (!el) return;
  el.addEventListener("change", () => {
    updatePriceImmediate();
    updateSelectionLine();
  });
});

/* -----------------------------
  9) PICKER (hidden input)
------------------------------ */
function ensureOurFileInput(){
  let input = document.getElementById("photo-upload");
  if (input) return input;

  input = document.createElement("input");
  input.type = "file";
  input.id = "photo-upload";
  input.accept = "image/*";
  input.multiple = true;
  input.style.display = "none";
  document.body.appendChild(input);
  return input;
}

function bindPicker(){
  const input = ensureOurFileInput();

  const open = () => {
    setError("");
    try { input.value = ""; } catch(e){}
    input.click();
  };

  uploadArea?.addEventListener("click", open);
  uploadArea?.addEventListener("keydown", (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      open();
    }
  });

  input.addEventListener("change", (e) => {
    const files = e.target.files;
    if (!files || !files.length) return;
    handleSelectedFiles(files);
  });
}

/* -----------------------------
  10) ADD TO CART (Step 4)
------------------------------ */
async function addAddOnsAsSeparateItems() {
  const selectedKeys = getSelectedAddOnKeys();
  if (!selectedKeys.length) return true;

  const items = [];

  for (const key of selectedKeys) {
    const cfg = ADD_ONS[key];
    const variantId = String(cfg?.variantId || "").trim();

    if (!variantId || variantId.startsWith("REPLACE_WITH")) {
      console.warn("Missing add-on variantId for", key, cfg);
      alert(T.addOnMisconfigured(T[cfg?.titleKey] || key));
      return false;
    }

    items.push({
      id: variantId,
      quantity: 1,
      properties: {
        [T.appliesTo]: (window.productTitle || T.styleFallback).trim()
      }
    });
  }

  const resp = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json", "Accept": "application/json" },
    body: JSON.stringify({ items })
  });

  if (!resp.ok) {
    const t = await resp.text().catch(() => "");
    console.error("Add-ons add failed:", resp.status, t);
    return false;
  }
  return true;
}

$("#add-to-cart")?.addEventListener("click", async (e) => {
  const btn = e.target instanceof HTMLElement ? e.target.closest("button") : null;
  if (!(btn instanceof HTMLButtonElement)) return;

  if (uploadedUrls.filter(Boolean).length < REQUIRED_IMAGES) {
    alert(T.stillUploading);
    return;
  }

  btn.disabled = true;
  const prevHTML = btn.innerHTML;
  btn.textContent = T.adding;

  const variantId = await getBaseVariantIdAsync();
  if (!variantId) {
    console.warn("No variant match for:", { selectedFrame, selectedSize });
    alert(T.variantMissing);
    btn.disabled = false;
    btn.innerHTML = prevHTML;
    return;
  }

  const fd = new FormData();
  fd.append("id", variantId);
  fd.append("quantity", "1");

  // internal properties
  fd.append("properties[_frame]", selectedFrame);
  fd.append("properties[_size]", normalizeSizeDisplay(selectedSize));
  fd.append("properties[_type]", selectedType);
  if (window.productTitle) fd.append("properties[_style]", window.productTitle);

  // visible message
  const msg = ($("#message-to-artist")?.value || "").trim();
  if (msg) fd.append(`properties[${T.msgLabel}]`, msg);

  for (let i = 0; i < REQUIRED_IMAGES; i++) {
    const idx = i + 1;

    const originalFile = uploadedFiles[i];
    if (originalFile) {
      const shadowFile = await makeShopifyShadowFile(originalFile, idx);
      fd.append(`properties[Pet photo ${idx}]`, shadowFile, shadowFile.name);
    } else {
      fd.append(`properties[Pet photo ${idx}]`, "");
    }

    fd.append(`properties[_cf_photo_${idx}]`, uploadedUrls[i] || "");
  }

  try {
    const resp = await fetch("/cart/add.js", { method: "POST", body: fd });
    if (!resp.ok) {
      const t = await resp.text().catch(() => "");
      console.error("Add to cart failed:", resp.status, t);
      alert(T.addToCartFail);
      btn.disabled = false;
      btn.innerHTML = prevHTML;
      return;
    }

    const okAddOns = await addAddOnsAsSeparateItems();
    if (!okAddOns) alert(T.addOnsFailedButMainAdded);

    window.location.href = "/checkout";
  } catch (err) {
    console.error("Network error add to cart", err);
    alert(T.networkError);
    btn.disabled = false;
    btn.innerHTML = prevHTML;
  }
});

/* -----------------------------
  11) INIT
------------------------------ */
(function init() {
  // debug (keep during testing)
  console.log("🌍 locale debug:", {
    LOCALE,
    LANG_KEY,
    ShopifyLocale: window.Shopify?.locale,
    htmlLang: document.documentElement.lang,
    path: location.pathname,
    search: location.search
  });

  $("#upload-required") && ($("#upload-required").textContent = String(REQUIRED_IMAGES));

  // Ensure defaults exist based on your HTML selections
  const initialFrame =
    document.querySelector(".frame-card.selected")?.dataset.frame ||
    document.querySelector(".frame-card")?.dataset.frame;
  if (initialFrame) selectedFrame = initialFrame;

  const initialSize =
    document.querySelector(".size-card.selected")?.dataset.size ||
    document.querySelector(".size-card")?.dataset.size;
  if (initialSize) selectedSize = initialSize;

  // ✅ Translate all hardcoded HTML labels/buttons/badges etc.
  applyStaticTranslations();

  bindPicker();
  renderPreviews();
  updateSelectionLine();
  updatePriceImmediate();

  gotoStep(1);

  console.log("✅ Customizer initialized", {
    REQUIRED_IMAGES, selectedType, selectedFrame, selectedSize
  });
})();